import { PuzzleOutlineIcon } from './PuzzleOutlineIcon';

/**
 * author: Google
 * id BBAC40CD-6A3A-4EEF-A381-DB7C8950995E
 * name puzzle-outline
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/puzzle-outline.svg
 * tags
 * - Gaming / RPG 
 */
export const JigsawOutlineIcon = PuzzleOutlineIcon;
export default JigsawOutlineIcon